import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { rp, fmtDate, fmtAcc, fmtTime, txBy } from "./format";

export const loadBanner = () => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    c.getContext("2d").drawImage(img, 0, 0);
    resolve({ data: c.toDataURL("image/png"), ratio: img.naturalWidth / img.naturalHeight });
  };
  img.onerror = () => resolve(null);
  img.src = "/brand-banner.webp";
});

export async function downloadMutasi(user, data) {
  const doc = new jsPDF();
  const banner = await loadBanner();
  if (banner) {
    doc.addImage(banner.data, "PNG", 14, 6, 20 * banner.ratio, 20);
  } else {
    doc.setTextColor(30, 64, 175);
    doc.setFontSize(16);
    doc.text("CU TUAH TALINO", 14, 16);
  }
  doc.setTextColor(71, 85, 105);
  doc.setFontSize(10);
  doc.text("Mutasi Buku Tabungan", 196, 14, { align: "right" });
  doc.setDrawColor(220, 38, 38);
  doc.setLineWidth(0.8);
  doc.line(14, 29, 196, 29);
  doc.setTextColor(15, 23, 42);
  doc.setFontSize(10);
  doc.text(`Nama: ${user.name}`, 14, 38);
  doc.text(`No. Anggota: ${user.member_no}   No. Rekening: ${fmtAcc(user.account_no)}`, 14, 44);
  doc.text(`Dicetak: ${fmtDate(new Date().toISOString())}`, 14, 50);
  const b = data.balances;
  doc.text(`Pokok: ${rp(b.pokok)}   Wajib: ${rp(b.wajib)}   Sukarela: ${rp(b.sukarela)}   Total: ${rp(b.total)}`, 14, 58);
  autoTable(doc, {
    startY: 64,
    head: [["Tanggal", "Jam", "Keterangan", "Jenis", "Masuk", "Keluar", "Diproses"]],
    body: data.transactions.map((t) => [
      fmtDate(t.created_at), fmtTime(t.created_at), t.description, t.type,
      t.direction === "in" ? rp(t.amount) : "-", t.direction === "out" ? rp(t.amount) : "-", txBy(t),
    ]),
    headStyles: { fillColor: [220, 38, 38] },
    styles: { fontSize: 8 },
  });
  doc.save(`mutasi-${user.member_no}.pdf`);
}
